export const containsNumber = (string) => {
  return /[0-9]/.test(string);
};

export const createChoiceIntro = (description, choiceNumber, lineStr, icon, label) => {
  let infoBarText = '';
  if (description) {
    infoBarText = description;
  }
  if (choiceNumber && lineStr && description) {
    infoBarText = `${choiceNumber}${lineStr}: ${description}`;
  }
  if (choiceNumber && lineStr && !description) {
    infoBarText = `${choiceNumber}${lineStr}`;
  }
  if (label) {
    infoBarText = label;
  }
  const infoBarData = [
    {
      iconId: icon,
      label: infoBarText,
    },
  ];

  return infoBarData;
};

const getCatalogTextByTextType = (textStructure, textType) => {
  let text = '';
  if (textStructure) {
    if (textStructure.texts && Array.isArray(textStructure.texts)) {
      const textObj = textStructure.texts.find((element) => {
        return element.typeId === textType;
      });
      if (textObj) {
        ({ text } = textObj);
      }
    }
  }

  return text;
};

/**
 * Function which search specific textType on all texts structure
 * obtained from getProductOffering API
 * @param productOffering object with all texts of the productOffering
 * @param textType typeId of the text to find
 * @returns string with the text
 */
export const getProductOfferingTextByType = (productOffering, textType) => {
  return getCatalogTextByTextType(productOffering, textType);
};

/**
 * Function which search specific textType on all texts structure obtained from getProductOffering API
 * @param productPromotion object with all texts of the promotion
 * @param textType typeId of the text to find
 * @returns string with the text
 */
export const getProductPromotionTextByType = (productPromotion, textType) => {
  return getCatalogTextByTextType(productPromotion, textType);
};

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    });
  }

  return mergeDeep(target, ...sources);
}


export const overwriteMerge = (destinationArray, sourceArray) => sourceArray;

export const replaceLocalizedString = (fullText, substitutions) => {
  if (fullText && substitutions) {
    return fullText.replace(/{\w+}/g, (match) => {
      return substitutions[match] || match;
    });
  }
};

export const areThereProductOfferingTypesIntoOfferArray = (offerProductOfferingTypes, productOfferingTypesToTest) => {
  if (offerProductOfferingTypes.length === 0 && productOfferingTypesToTest.length === 0) {
    return true;
  }
  if (offerProductOfferingTypes.some(element => productOfferingTypesToTest.includes(element.id))) {
    return true;
  }

  return false;
};

export const findNested = (obj, key, memo) => {
  let memo2 = memo;
  const proto = Object.prototype;
  const ts = proto.toString;

  Object.keys(obj).forEach((i) => {
    if (i === key) {
      memo2 = obj[i];
    } else if (ts.call(obj[i]) === '[object Array]' || ts.call(obj[i]) === '[object Object]') {
      memo2 = findNested(obj[i], key, memo2);
    }
  });

  return memo2;
};

export const intersection = (arr1, arr2) => {
  const map = {};
  const result = [];

  // Mapear los elementos del primer array y contar su frecuencia
  arr1.forEach((item) => {
    if (map[item]) {
      map[item] += 1;
    } else {
      map[item] = 1;
    }
  });

  // Iterar sobre el segundo array y reducir su frecuencia en el mapa
  arr2.forEach((item) => {
    if (map[item] > 0) {
      result.push(item);
      map[item] -= 1;
    }
  });

  return result;
};

export const removeDuplicates = (array, arrayToClean) => {
  const countMap = array.reduce((acc, val) => {
    acc[val] = (acc[val] || 0) + 1;
    return acc;
  }, {});

  return arrayToClean.filter((item) => {
    if (countMap[item] && countMap[item] > 0) {
      countMap[item] -= 1;
      return false;
    }
    return true;
  });
};


export const deepSearchAll = (obj, property) => {
  let result = [];

  function search(obj) {
      // Si el objeto actual no es un objeto, termina la función
      if (typeof obj !== 'object' || obj === null) {
          return;
      }

      // Si la propiedad actual existe, añade su valor al array resultante
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
          result.push(obj[property]);
      }

      // Recorre todas las propiedades del objeto actual
      for (let key in obj) {
          // Verifica que la propiedad sea del objeto y no heredada del prototipo
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
              // Llamada recursiva para seguir buscando en niveles más profundos
              search(obj[key]);
          }
      }
  }

  // Inicia la búsqueda
  search(obj);

  // Devuelve el array con todos los valores encontrados
  return result;
}
